const module = {
  namespaced: true,
  state: {
    isVisible: false,
    route: null
  },
  mutations: {
    clearRoute: (state, v) => {
      state.route = null
    },
    setIsVisible: (state, v) => {
      state.isVisible = v
    },
    setRoute: (state, v) => {
      state.route = v
      state.isVisible = true
    }
  }
}

export default module
